<template>
<div>
  <AgeGate />
    <Header />
        <!-- <BurgerMenu /> -->
 
  <SmoothScrollLand>
  <div class="home home-true" data-scroll-section data-scroll>
      
      <LandingFirst />
      <Footer />
  </div>
    </SmoothScrollLand>
    <CookiesBar />
    </div>
</template>

<script>
import SmoothScrollLand from '@/components/SmoothScrollLand';
import LandingFirst from "@/components/smartComponents/LandingFirst";
import CookiesBar from "@/components/CookiesBar";
//import Header from "@/components/layout/Header";
import AgeGate from '@/components/smartComponents/AgeGate';
import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";

export default {
  name: "Home",
  components: {
  
    LandingFirst,
   Header,
   SmoothScrollLand,
   CookiesBar,
   AgeGate,
    Footer
  },
  data() {
    return {
      components: []
    };
  },
  mounted() {
    // console.log("11111111111");
  },
  methods: {}
};
</script>
